import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["Component"];
import PropTypes from 'prop-types';
import React from 'react';
import DropdownOption from '../DropdownOption';
import DropdownList from '../DropdownList';
import { getObjectValue } from '../tools/util';
import SelectOptions from '../SelectOptions';
import Loading from '../Loading';
import { canTouch, pureTouch } from '../tools/touch';
var sExpanded = Symbol('expanded'); // 级联下拉列表

export default function CascaderDropdownLists(_ref) {
  var state = _ref.state,
      update = _ref.update,
      data = _ref.data,
      optionRender = _ref.optionRender,
      childrenName = _ref.childrenName,
      hasChildrenName = _ref.hasChildrenName,
      valueName = _ref.valueName,
      showAll = _ref.showAll,
      dropdownListProps = _ref.dropdownListProps,
      searchProps = _ref.searchProps,
      onMouseOver = _ref.onMouseOver;
  var searchText = searchProps.searchText,
      searchLoading = searchProps.searchLoading;

  if (!state[sExpanded]) {
    state[sExpanded] = [];
  }

  var expandedListByLevel = state[sExpanded];
  var lists = [];

  var getChildren = function getChildren(item) {
    return getObjectValue(item, childrenName);
  };

  var getHasChildren = function getHasChildren(item) {
    return getObjectValue(item, hasChildrenName);
  }; // 判断两个选项是否相等，如果有valueName使用value判断，否则使用引用判断


  var isOptionEqual = valueName ? function (lhs, rhs) {
    var getValue = function getValue(item) {
      return item ? getObjectValue(item, valueName) : null;
    };

    return getValue(lhs) === getValue(rhs);
  } : function (lhs, rhs) {
    return lhs === rhs;
  }; // 根据展开状态，递归计算当前的下拉列表

  function addToList(list, parent, parentIndex) {
    var index = parent.length;
    lists.push({
      parentIndex: parentIndex,
      parent: parent,
      list: list
    });
    var curExpanded = expandedListByLevel[index];

    if (curExpanded != null) {
      var expendIndex = list.findIndex(function (item) {
        return isOptionEqual(item, curExpanded);
      });
      var expandedItem = list[expendIndex] || {};
      var children = getChildren(expandedItem); // 如果是

      if (children && children.length) {
        addToList(children, parent.concat(expandedItem), parentIndex.concat(expendIndex));
        return;
      }

      if (getHasChildren(expandedItem) && !children) {
        lists.push({
          loading: true
        });
      }
    }
  }

  addToList(data, [], []);
  var renderedList = searchLoading ? lists.slice(0, 1) : lists;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderedList.map(function (_ref2, level) {
    var list = _ref2.list,
        parent = _ref2.parent,
        parentIndex = _ref2.parentIndex,
        loading = _ref2.loading;

    if (loading) {
      return /*#__PURE__*/React.createElement(DropdownList, _extends({
        key: level,
        height: dropdownListProps.maxHeight
      }, dropdownListProps), /*#__PURE__*/React.createElement(DropdownOption, {
        className: "jmtd-dropdown-loading-option"
      }, /*#__PURE__*/React.createElement(Loading, {
        loading: true,
        size: "small"
      })));
    }

    var listContent = list.map(function (item, index) {
      var children = getChildren(item);
      var expanded = isOptionEqual(expandedListByLevel[level], item);
      var path = parent.concat(item);

      function call(callback) {
        return callback(item, searchText, {
          level: level,
          index: index,
          expanded: expanded,
          path: path
        });
      }

      var _call = call(optionRender),
          _call$Component = _call.Component,
          Component = _call$Component === void 0 ? DropdownOption : _call$Component,
          otherProps = _objectWithoutProperties(_call, _excluded); // 触摸时，点击出下一个选项


      var props = {};

      var expand = function expand() {
        expandedListByLevel[level] = item;
        expandedListByLevel.splice(level + 1);
        call(onMouseOver);
        update();
      };

      if (canTouch) {
        props.onClick = function (e) {
          if (e.target.tagName.toUpperCase() !== 'INPUT') {
            expand();
          }
        };

        if (!pureTouch) {
          props.onMouseOver = expand;
        }
      } else {
        props.onMouseOver = expand;
      }

      return /*#__PURE__*/React.createElement(Component, _extends({
        key: parentIndex.concat(index).join('-'),
        expanded: expanded,
        showArrow: children && children.length > 0 || getHasChildren(item) && !children
      }, props, otherProps));
    });
    return /*#__PURE__*/React.createElement(DropdownList, _extends({
      key: level
    }, dropdownListProps), level === 0 ? /*#__PURE__*/React.createElement(SelectOptions, searchProps, showAll, listContent) : listContent);
  }));
}
CascaderDropdownLists.propTypes = {
  childrenName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  hasChildrenName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  valueName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  data: PropTypes.any.isRequired,
  dropdownListProps: PropTypes.object,
  optionRender: PropTypes.func,
  searchProps: PropTypes.object,
  showAll: PropTypes.node,
  state: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func
};
CascaderDropdownLists.defaultProps = {
  childrenName: 'children',
  hasChildrenName: 'hasChildren',
  valueName: null,
  dropdownListProps: {},
  optionRender: function optionRender(item) {
    return item.label;
  },
  searchProps: {},
  showAll: null,
  onMouseOver: function onMouseOver() {}
};